import React from 'react'
import styled from "styled-components";
import { Box, Flex } from 'rebass'

import BlockingButton from '~/components/blocking-button'
import sizes from '~/components/sizes'


import { __ } from '~/i18n'

const Buttons = styled.div`
  margin-top: 20px;
  
  .ui.button {
    margin-bottom: 8px;
  }
`;

@sizes
export default class CheckoutButtons extends React.PureComponent {
  handleBack = () => {
    const { onBack } = this.props;

    if(onBack) {
      onBack()
    }
  };

  handleContinue = () => {
    const { onContinue } = this.props;

    if(onContinue) {
      onContinue()
    }
  };

  render() {
    const { loading, continueDisabled , isTiny} = this.props;

    return (
      <Buttons>
        <Flex flexWrap='wrap' py={ 4 } alignItems={ 'center' } mx={ -4 } flexDirection={!isTiny ? 'row-reverse': null}>
          <Box px={ 4 } width={ [ 1, 0.5 ] }>
            <BlockingButton disabled={ continueDisabled } fluid positive onClick={ this.handleContinue } loading={ loading }>{ __('Continue') }</BlockingButton>
          </Box>
          <Box px={ 4 } width={ [ 1, 0.5 ] }>
            <BlockingButton onClick={ this.handleBack } fluid basic loading={ loading }>{ __('Previous step') }</BlockingButton>
          </Box>
        </Flex>
      </Buttons>
    )
  }
}
